export type TransactionType = 'purchase' | 'sales';

interface InvoiceLabels {
  // Party labels
  partyLabel: string;              // "Supplier" | "Customer"
  partyPlaceholder: string;        // "Select supplier..." | "Select customer..."

  // Account labels
  transactionAccountLabel: string; // "Purchase Account" | "Sales Account"
  transactionAccountPlaceholder: string;

  // Invoice reference labels
  invoiceNumberLabel: string;      // "Invoice #"
  invoiceDateLabel: string;        // "Invoice Date"

  // Voucher labels
  voucherButtonLabel: string;      // "Create Purchase Voucher" | "Create Sales Voucher"
  voucherCreatingLabel: string;    // "Creating Purchase Voucher..." | "Creating Sales Voucher..."

  // Workflow labels
  workflowTitle: string;           // "Purchase Invoice Entry" | "Sales Invoice Entry"
  rulesDialogTitle: string;        // "Purchase Entry Rules" | "Sales Entry Rules"

  // Success messages
  successMessage: (count: number) => string;
}

export function getInvoiceLabels(type: TransactionType): InvoiceLabels {
  const isPurchase = type === 'purchase';

  return {
    partyLabel: isPurchase ? 'Supplier' : 'Customer',
    partyPlaceholder: isPurchase ? 'Select supplier...' : 'Select customer...',

    transactionAccountLabel: isPurchase ? 'Purchase Account' : 'Sales Account',
    transactionAccountPlaceholder: isPurchase
      ? 'Select purchase account...'
      : 'Select sales account...',

    invoiceNumberLabel: 'Invoice #',
    invoiceDateLabel: 'Invoice Date',

    voucherButtonLabel: isPurchase
      ? 'Create Purchase Voucher'
      : 'Create Sales Voucher',
    voucherCreatingLabel: isPurchase
      ? 'Creating Purchase Voucher...'
      : 'Creating Sales Voucher...',

    workflowTitle: `${isPurchase ? 'Purchase' : 'Sales'} Invoice Entry`,
    rulesDialogTitle: `${isPurchase ? 'Purchase' : 'Sales'} Entry Rules`,

    successMessage: (count: number) =>
      `${count} ${isPurchase ? 'purchase' : 'sales'} invoice${count !== 1 ? 's' : ''} successfully posted to Tally.`,
  };
}
